import { AnnouncerContextProvider } from "@mwt/announcer";
import {
  SessionContextProvider,
  TelemetryContextProvider,
} from "@smb/web-telemetry";
import { useMemo, Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ApolloEndpointProvider } from "../apollo/apollo-endpoint-provider/ApolloEndpointProvider";
import { getGlobalAnonymousClient } from "../apollo/apolloClient";
import { InstrumentationKeyProvider } from "../shared/telemetry/telemetry-context/InstrumentationKeyProvider";

import { FluentProvider } from "./common/fluent-provider/FluentProvider";
import { FullParentLoader } from "./common/full-parent-loader/FullParentLoader";
import { LocalizationProvider } from "./common/localization-context/LocalizationContext";
import { RouteSwitcher } from "./RouteSwitcher";

export const App: React.FC = () => {
  // redirect to unsupported browser error page.
  useEffect(() => {
    const ua = navigator.userAgent;
    if (ua && (ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1)) {
      window.location.pathname = "./ie.html";
    }
  }, []);
  const globalApolloClient = useMemo(() => getGlobalAnonymousClient(), []);
  const AnnouncerContextProviderWithChildren: any = AnnouncerContextProvider;
  return (
    <LocalizationProvider>
      <TelemetryContextProvider>
        <SessionContextProvider>
          <InstrumentationKeyProvider apolloClient={globalApolloClient}>
            <ApolloEndpointProvider>
              <Suspense fallback={<FullParentLoader />}>
                <FluentProvider>
                  <AnnouncerContextProviderWithChildren>
                    <BrowserRouter>
                      <RouteSwitcher />
                    </BrowserRouter>
                  </AnnouncerContextProviderWithChildren>
                </FluentProvider>
              </Suspense>
            </ApolloEndpointProvider>
          </InstrumentationKeyProvider>
        </SessionContextProvider>
      </TelemetryContextProvider>
    </LocalizationProvider>
  );
};
